export const CHURN_REASONS = [
  {
    id: 'price',
    title: 'Zu teuer',
    description: 'Mein Budget ist knapp oder das Abo ist mir zu teuer.',
    actions: [
      {
        title: 'Nachfragen',
        description: 'Frag nach, ob kein Kapital vorhanden ist oder das Abo als zu teuer empfunden wird.',
      },
      {
        title: 'Angebot',
        description: 'Biete 50 % Rabatt auf die nächsten zwei Monate an.',
      },
      {
        title: 'Wenn abgelehnt',
        description: 'Kündige und frage, zu welchem Preis der Kunde zufrieden wäre.',
      },
    ],
  },
  {
    id: 'competition',
    title: 'Wechsel zu anderem Anbieter',
    description: 'Ich plane zu einem anderen Anbieter zu wechseln.',
    actions: [
      {
        title: 'Nachfragen',
        description: 'Zu welchem Anbieter möchtest du wechseln?',
      },
      {
        title: 'Verstehen',
        description: 'Warum wechselst du und was können wir ändern, damit du bleibst?',
      },
      {
        title: 'Angebot',
        description: 'Biete 50 % Rabatt auf die nächsten zwei Monate an.',
      },
      {
        title: 'Wenn abgelehnt',
        description: 'Kündige und lass den Kunden wissen, dass wir ihn vermissen werden.',
      },
    ],
  },
  {
    id: 'missing-features',
    title: 'Fehlende Funktionen',
    description: 'Mir fehlen wichtige Funktionen oder Features.',
    actions: [
      {
        title: 'Nachfragen',
        description: 'Welche Funktionen würdest du dir wünschen?',
      },
      {
        title: 'Angebot',
        description: 'Biete 50 % Rabatt auf die nächsten zwei Monate an und gib uns Zeit, die Wünsche zu erfüllen.',
      },
      {
        title: 'Wenn abgelehnt',
        description: 'Kündige und lass den Kunden wissen, dass wir ihn vermissen werden.',
      },
    ],
  },
  {
    id: 'technical-issues',
    title: 'Technische Probleme',
    description: 'Ich habe technische Probleme bei der Nutzung.',
    actions: [
      {
        title: 'Support',
        description: 'Biete einen kostenlosen Support-Call an.',
      },
      {
        title: 'Pause',
        description: 'Pausiere das Abo und finde gemeinsam die Ursache.',
      },
      {
        title: 'Angebot',
        description: 'Biete 50 % Rabatt auf die nächsten zwei Monate an.',
      },
      {
        title: 'Wenn abgelehnt',
        description: 'Kündige und lass den Kunden wissen, dass wir ihn vermissen werden.',
      },
    ],
  },
  {
    id: 'other',
    title: 'Anderer Grund',
    description: 'Es gibt einen anderen Grund, den ich erklären möchte.',
    actions: [
      {
        title: 'Nachfragen',
        description: 'Warum möchtest du kündigen?',
      },
      {
        title: 'Support',
        description: 'Biete einen kostenlosen Support-Call an.',
      },
      {
        title: 'Angebot',
        description: 'Biete 50 % Rabatt auf die nächsten zwei Monate an.',
      },
      {
        title: 'Wenn abgelehnt',
        description: 'Kündige und lass den Kunden wissen, dass wir ihn vermissen werden.',
      },
    ],
  },
]
